import React from 'react';
import BaseMutateRouteMutateSingleVoyage
    from "@containers/singleVoyage/mutateVoyage/route/mutateRoute/BaseMutateRouteMutateSingleVoyage";
import {
    useRootContextMutateSingleVoyage
} from "@containers/singleVoyage/mutateVoyage/context/rootContext/hooks/useRootContextMutateSingleVoyage";
import {
    useStateMutateRouteWithHotUpdateSingleVoyage
} from "@containers/singleVoyage/mutateVoyage/route/mutateRoute/hooks/useStateMutateRouteWithHotUpdateSingleVoyage";
import {ErrorMessage} from "@hooks/validate/types";
import {
    useViewContextMutateSingleVoyage
} from "@containers/singleVoyage/mutateVoyage/context/viewContext/hooks/useViewContextMutateSingleVoyage";
import {
    buildValidateSchemaRouteInfoMutateSingleVoyages
} from "@containers/singleVoyage/mutateVoyage/saveVoyage/validate/validateSchema";
import {useValidationValue} from "@hooks/validate/useValidationValue";


const routeInfoValidateSchema = buildValidateSchemaRouteInfoMutateSingleVoyages()


const BaseMutateRouteMutateWidthHotUpdateSingleVoyage = ({
                                                             error,
                                                             errorMessage,
                                                         }: {
    error?: boolean,
    errorMessage?: ErrorMessage,
}) => {

    const {
        routeInfo,
        accountId,
    } = useRootContextMutateSingleVoyage()

    const stateMutateSingleVoyage = useStateMutateRouteWithHotUpdateSingleVoyage({initial: routeInfo})

    return (
        <>
            <BaseMutateRouteMutateSingleVoyage
                stateMutateSingleVoyage={stateMutateSingleVoyage}
                error={error}
                errorMessage={errorMessage}
                accountId={accountId}
            />
        </>
    );
};

const MutateRouteMutateWidthHotUpdateAndShowErrorsSingleVoyage = () => {

    const {
        routeInfo,
        accountId,
    } = useRootContextMutateSingleVoyage()

    const stateMutateSingleVoyage = useStateMutateRouteWithHotUpdateSingleVoyage({initial: routeInfo})


    const [_, error, errorMessage] = useValidationValue({
        value: {
            title: stateMutateSingleVoyage.title,
            deviceId: stateMutateSingleVoyage.deviceId,
            accountId
        },
        validateSchema: routeInfoValidateSchema,
        dependency: [
            stateMutateSingleVoyage.title,
            stateMutateSingleVoyage.deviceId,
            accountId
        ],
        initialShowError: true
    })

    return (
        <>
            <BaseMutateRouteMutateSingleVoyage
                stateMutateSingleVoyage={stateMutateSingleVoyage}
                error={error}
                errorMessage={errorMessage}
                accountId={accountId}
            />
        </>
    );
};


const MutateRouteMutateWithHotUpdateSingleVoyage = () => {

    const {touchedEditRouteInfo} = useViewContextMutateSingleVoyage();

    if (touchedEditRouteInfo) {
        return (
            <MutateRouteMutateWidthHotUpdateAndShowErrorsSingleVoyage/>
        )
    }
    return (
        <BaseMutateRouteMutateWidthHotUpdateSingleVoyage/>
    );
};

export default MutateRouteMutateWithHotUpdateSingleVoyage;
